(function (angular) {
    'use strict';

    angular.module('customChannel')
        /**
         *
         */
        .controller('CustomChannelIdCtrl',
            ['$scope', 'growlService', '$uibModalInstance', 'channelId',
                function ($scope, growlService, $uibModalInstance, channelId) {

                    $scope.channelId = channelId;

                    $scope.copy = function () {
                        var copyTextarea = document.querySelector('#channel-id');
                        copyTextarea.select();
                        try {
                            document.execCommand('copy');
                            growlService.success("Id copied to clipboard");
                        }
                        catch (err) {
                            growlService.danger("Id not copied, try manualy");
                        }
                    };

                    $scope.cancel = function () {
                        $uibModalInstance.dismiss('cancel');
                    };
                }]);


})(window.angular);
